<template>
  <v-dialog
    v-model="dialog"
    :max-width="maxWidth"
    :min-width="minWidth"
  >
    <template v-slot:activator="{ on, attrs }">
      <slot name="activator" :on="on" :attrs="attrs">
        <div class="d-flex justify-center align-center">
          <v-icon
            :color="iconColor"
            :size="iconSize"
            v-bind="attrs"
            v-on="on"
          >
            {{ icon }}
          </v-icon>
        </div>
      </slot>
    </template>
    <v-card>
      <div class="d-flex justify-end">
        <v-icon @click.stop="dialog = false" class="ma-2">
          close
        </v-icon>
      </div>
      <div>
        <slot />
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'ClosableDialog',
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    close() {
      this.dialog = false;
    },
    open() {
      this.dialog = true;
    },
  },
  props: {
    icon: {
      type: String,
      default: 'add',
    },
    iconSize: {
      type: String,
      default: undefined,
    },
    iconColor: {
      type: String,
      default: 'grey',
    },
    maxWidth: {
      type: String,
      default: '700px',
    },
    minWidth: {
      type: String,
      default: '400px',
    },
  },
};
</script>
